module.exports = __webpack_public_path__ + "img/intro_6.49aaedc4.jpeg";